export default "__VITE_ASSET__BSK54hyo__"